export const normalizePrograma = (text) => {
  if (!text) return "";
  return String(text)
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
};

export const nombreDesdeFilaPrueba = (r) => {
  if (!r || typeof r !== "object") return "";
  const partes = [r.primer_nombre, r.segundo_nombre, r.primer_apellido, r.segundo_apellido].filter(
    (x) => x != null && String(x).trim() !== ""
  );
  if (partes.length) return partes.join(" ").trim();
  const direct =
    r.nombreCompleto ||
    r.nombre_completo ||
    r.NombreCompleto ||
    r.nombre_estudiante ||
    r.NombreEstudiante ||
    r.nombre ||
    r.Nombre ||
    r.estudiante ||
    r.Estudiante;
  if (direct != null && String(direct).trim()) return String(direct).trim();
  return "";
};

const sortRowsByPeriodo = (rows) =>
  [...(rows || [])].sort((a, b) => {
    const ya = Number(a.anio) || 0;
    const yb = Number(b.anio) || 0;
    if (ya !== yb) return ya - yb;
    const sa = Number(a.semestre) || 0;
    const sb = Number(b.semestre) || 0;
    if (sa !== sb) return sa - sb;
    const ia = Number(a.Intento) || 0;
    const ib = Number(b.Intento) || 0;
    if (ia !== ib) return ia - ib;
    return (Number(a.OrdenEvaluacion) || 0) - (Number(b.OrdenEvaluacion) || 0);
  });

export const ultimoTotalPorEstudiante = (rows, programaSeleccionado) => {
  const want = normalizePrograma(programaSeleccionado);
  if (!want) return [];

  const filtradas = (rows || []).filter((r) => {
    const p = normalizePrograma(r.programa || r.programa_nombre || r.Programa || "");
    if (!p) return true;
    return p === want;
  });

  const ordenadas = sortRowsByPeriodo(filtradas);
  const ultimoPorCorreo = new Map();
  ordenadas.forEach((r) => {
    const correo = (r.Correo || r.correo || "").trim();
    if (!correo) return;
    const total = Number(r.Total);
    if (!Number.isFinite(total)) return;
    const nombre = nombreDesdeFilaPrueba(r);
    ultimoPorCorreo.set(correo.toLowerCase(), { correo, total, nombre });
  });

  return [...ultimoPorCorreo.values()];
};

export const quantileSorted = (sortedAsc, q) => {
  if (!sortedAsc.length) return null;
  if (sortedAsc.length === 1) return sortedAsc[0];
  const pos = (sortedAsc.length - 1) * q;
  const base = Math.floor(pos);
  const rest = pos - base;
  const a = sortedAsc[base];
  const b = sortedAsc[Math.min(base + 1, sortedAsc.length - 1)];
  return a + rest * (b - a);
};

export const computeBoxPlot = (totals) => {
  const sorted = [...totals].filter((n) => Number.isFinite(n)).sort((a, b) => a - b);
  const n = sorted.length;
  if (!n) {
    return {
      min: null,
      max: null,
      q1: null,
      median: null,
      q3: null,
      iqr: null,
      lowerFence: null,
      upperFence: null,
      whiskerLow: null,
      whiskerHigh: null,
    };
  }

  const q1 = quantileSorted(sorted, 0.25);
  const median = quantileSorted(sorted, 0.5);
  const q3 = quantileSorted(sorted, 0.75);
  const iqr = q3 - q1;
  const lowerFence = q1 - 1.5 * iqr;
  const upperFence = q3 + 1.5 * iqr;

  const inside = sorted.filter((v) => v >= lowerFence && v <= upperFence);
  const whiskerLow = inside.length ? Math.min(...inside) : sorted[0];
  const whiskerHigh = inside.length ? Math.max(...inside) : sorted[n - 1];

  return {
    min: sorted[0],
    max: sorted[n - 1],
    q1,
    median,
    q3,
    iqr,
    lowerFence,
    upperFence,
    whiskerLow,
    whiskerHigh,
  };
};
